import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ErrorMessage, FieldArray, Formik } from 'formik';
import { Autocomplete, createTheme, Divider, FormHelperText, Grid2, IconButton, TextField, Typography, useTheme } from '@mui/material';
import * as Yup from 'yup';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { IoMdClose } from 'react-icons/io';
import { useAddWorkflowMutation, useGetEntityCategoryListQuery } from 'store/slices/apis/workflowSlice';
import { useGetAllRoleQuery } from 'store/slices/apis/rolePackageSlice';
import DeleteIcon from '@mui/icons-material/Delete';
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

const numbers = Array.from({ length: 100 }, (_, i) => i + 1);

export default function AddWorkFlow(props) {
    const { open, cancel, openNotification } = props;

    const newtheme = useTheme();
    const { projectId } = useParams();
    const [categoryList, setCategoryList] = useState([]);

    const [addWorkflowResFun, addWorkflowRes] = useAddWorkflowMutation();
    const categoryRes = useGetEntityCategoryListQuery();
    const rolesData = useGetAllRoleQuery({ projectId })

    const [formData, setFormData] = useState({
        projectId: projectId,
        WorkflowName: '',
        entityName: '',
        active: true,
        steps: [{ roles: [], stepName: '', tat: '', sequence: 1 }],
    })

    const theme = createTheme({
        components: {

            MuiTextField: {
                styleOverrides: {
                    root: {
                        border: '2px solid #e6e6e6', '& .MuiFilledInput-input': {
                            backgroundColor: '#fff',
                            color: '#252525',
                            fontSize: '16px'
                        },
                        '& .MuiFilledInput-root::before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root::after': {
                            borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#696969',
                            fontSize: '14px'
                        },
                        '& .MuiFormLabel-root': {
                            fontSize: '15px'
                        },
                        '& .MuiFilledInput-root.Mui-disabled:before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root': {
                            backgroundColor: '#fff'
                        },
                        '& .MuiFilledInput-input': {
                            backgroundColor: 'none',
                            fontSize: '14px'
                        },
                        "& .MuiInputLabel-root.Mui-disabled": {
                            color: "#696969",
                        },
                        "& .MuiFilledInput-root.Mui-disabled": {
                            backgroundColor: "#fff",
                            color: "inherit",
                        },
                        "& .MuiFilledInput-input.Mui-disabled": {
                            WebkitTextFillColor: "#696969",
                            opacity: "none",
                        },
                    },
                },
            }
        },
    });

    const validationSchema = Yup.object({
        WorkflowName: Yup.string().required("Workflow name field is required."),
        entityName: Yup.string().required("Entity type field is required."),
        steps: Yup.array()
            .of(
                Yup.object().shape({
                    stepName: Yup.string().required('Level name is required'),
                    tat: Yup.string().required('TAT field is required'),
                    roles: Yup.array()
                        .of(
                            Yup.object().shape({
                                roleId: Yup.string().required('Role is required')
                            })
                        )
                        .min(1, 'At least one role is required')
                })
            )
            .min(1, 'At least one level is required'),
    });

    React.useEffect(() => {
        if (categoryRes?.isSuccess) {
            setCategoryList(categoryRes?.data?.data?.[0]?.items)
        }
    }, [categoryRes])

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        // const updatedPayload = {
        //     ...values,
        //     roles: values.roles.map((id, i) => ({ roleId: id, sequence: i + 1 }))
        // };
        // console.log(values);

        addWorkflowResFun(values)
    };

    React.useEffect(() => {
        if (addWorkflowRes?.isSuccess) {
            if (addWorkflowRes?.data?.status == 'success') {
                openNotification(addWorkflowRes?.data?.message, 'success')
            } else {
                openNotification(addWorkflowRes?.data?.message, 'error')
            }
            cancel();
        }
    }, [addWorkflowRes?.isSuccess]);


    React.useEffect(() => {
        if (addWorkflowRes?.isError) {
            if (addWorkflowRes?.error?.data?.status == 'fail') {
                openNotification(addWorkflowRes?.error?.data?.message, 'error')
            } else {
                openNotification('Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [addWorkflowRes?.isError]);

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={open}
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{'New Workflow'}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: '20px' }} /> */}
                    <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080 " }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ mt: 1 }}>
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, setTouched }) => (
                                <form onSubmit={handleSubmit}>

                                    <Grid2 container spacing={2}>

                                        <Grid2 size={{ xs: 12, md: 6 }}>
                                            <TextField
                                                id="outlined-multiline-static2"
                                                label="Workflow Name"
                                                name="WorkflowName"
                                                placeholder='Enter Workflow Name'
                                                fullWidth
                                                value={values?.WorkflowName}
                                                onChange={handleChange}
                                                onBlur={() => setTouched({ ...touched, WorkflowName: true })}
                                                slotProps={{ inputLabel: { shrink: true } }}
                                                variant="filled"
                                            />
                                            {touched?.WorkflowName && errors?.WorkflowName &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.WorkflowName}`}</FormHelperText>
                                            }
                                        </Grid2>
                                        <Grid2 size={{ xs: 12, md: 6 }}>
                                            <Autocomplete
                                                options={categoryList}
                                                getOptionLabel={(option) => option?.value}
                                                value={categoryList?.find((option) => option?.value === values?.entityName) || null}
                                                onChange={(_, newValue) => setFieldValue("entityName", newValue ? newValue?.value : "")}
                                                onBlur={() => setTouched({ ...touched, entityName: true })}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Entity Type"
                                                        placeholder='Select Entity Type'
                                                        name="entityName"
                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                        variant="filled"
                                                    />
                                                )}
                                                ListboxProps={{
                                                    sx: { fontSize: "13px" },
                                                }}
                                            />
                                            {touched?.entityName && errors?.entityName &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.entityName}`}</FormHelperText>
                                            }

                                        </Grid2>
                                        {/* <Grid2 size={12}>
                                            <Autocomplete
                                                multiple
                                                options={rolesData?.data?.data}
                                                getOptionLabel={(option) => option?.displayName || ''}
                                                value={rolesData?.data?.data.filter((option) =>
                                                    (values?.steps || []).some((r) => r.roleId === option?.id)
                                                )}
                                                onChange={(_, newSelected) => {
                                                    const updated = newSelected.map((item) => ({ roleId: item?.id }));
                                                    setFieldValue("steps", updated);
                                                }}
                                                onBlur={() => setTouched({ ...touched, steps: true })}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Roles"
                                                        placeholder="Select Role"
                                                        name="steps"
                                                        variant="filled"
                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                        error={Boolean(touched?.steps && errors?.steps)}
                                                        helperText={
                                                            touched?.steps && errors?.steps ? (
                                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>
                                                                    {errors.steps}
                                                                </FormHelperText>
                                                            ) : null
                                                        }
                                                    />
                                                )}
                                                ListboxProps={{
                                                    sx: { fontSize: '13px' },
                                                }}
                                            />
                                            {touched?.steps && errors?.steps &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.steps}`}</FormHelperText>
                                            }
                                        </Grid2> */}
                                        <Grid2 size={{ xs: 12, md: 12 }}>
                                            <FieldArray name="steps">
                                                {({ push, remove }) => (
                                                    <>
                                                        {values?.steps?.map((role, index) => {
                                                            const selectedRoleIds = role?.selectedRoles?.map(r => r.roleId) || [];

                                                            return (
                                                                <Box key={index} sx={{ mb: 2 }}>
                                                                    <Grid2 container spacing={1}>
                                                                        <Grid2 size={{ xs: 12, md: 3 }}>
                                                                            <TextField
                                                                                id={`steps[${index}].stepName`}
                                                                                label="Level Name"
                                                                                name={`steps[${index}].stepName`}
                                                                                placeholder="Enter Level Name"
                                                                                fullWidth
                                                                                value={values?.steps?.[index]?.stepName}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                slotProps={{ inputLabel: { shrink: true } }}
                                                                                variant="filled"
                                                                            />
                                                                            {touched?.steps?.[index]?.stepName && errors?.steps?.[index]?.stepName &&
                                                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.steps?.[index]?.stepName}`}</FormHelperText>
                                                                            }
                                                                        </Grid2>
                                                                        <Grid2 size={{ xs: 12, md: 3 }}>
                                                                            <Autocomplete
                                                                                options={numbers} // [1, 2, 3, ..., 100]
                                                                                getOptionLabel={(option) => option.toString()}
                                                                                value={
                                                                                    typeof values?.steps?.[index]?.tat === 'number'
                                                                                        ? values?.steps[index].tat
                                                                                        : null
                                                                                }
                                                                                onChange={(_, newValue) =>
                                                                                    setFieldValue(`steps[${index}].tat`, newValue ?? null)
                                                                                }
                                                                                onBlur={() =>
                                                                                    setTouched({
                                                                                        ...touched,
                                                                                        steps: {
                                                                                            ...touched.steps,
                                                                                            [index]: {
                                                                                                ...(touched.steps?.[index] || {}),
                                                                                                tat: true,
                                                                                            },
                                                                                        },
                                                                                    })
                                                                                }
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label={`Level ${index + 1}`}
                                                                                        placeholder="Select TAT"
                                                                                        name={`steps[${index}].tat`}
                                                                                        variant="filled"
                                                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                                                    />
                                                                                )}
                                                                                ListboxProps={{ sx: { fontSize: '13px' } }}
                                                                            />
                                                                            {touched?.steps?.[index]?.tat && errors?.steps?.[index]?.tat &&
                                                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.steps?.[index]?.tat}`}</FormHelperText>
                                                                            }
                                                                            {/* <TextField
                                                                                id={`steps[${index}].tat`}
                                                                                label="TAT"
                                                                                name={`steps[${index}].tat`}
                                                                                placeholder="Enter TAT"
                                                                                fullWidth
                                                                                value={values?.steps?.[index]?.tat}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                slotProps={{ inputLabel: { shrink: true } }}
                                                                                variant="filled"
                                                                            />
                                                                            {touched?.steps?.[index]?.tat && errors?.steps?.[index]?.tat &&
                                                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.steps?.[index]?.tat}`}</FormHelperText>
                                                                            } */}
                                                                        </Grid2>
                                                                        <Grid2 size={{ xs: 12, md: index > 0 ? 5 : 6 }}>
                                                                            <Autocomplete
                                                                                multiple
                                                                                options={rolesData?.data?.data || []}
                                                                                getOptionLabel={(option) => option?.displayName || ''}
                                                                                value={
                                                                                    values?.steps?.[index]?.roles?.map((r) =>
                                                                                        rolesData?.data?.data?.find((opt) => opt.id === r.roleId)
                                                                                    ).filter(Boolean) || []
                                                                                }
                                                                                onChange={(_, newSelected) => {
                                                                                    const updated = newSelected.map(item => ({ roleId: item?.id }));
                                                                                    setFieldValue(`steps[${index}].roles`, updated);
                                                                                }}
                                                                                onBlur={handleBlur}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label={`Level ${index + 1}`}
                                                                                        placeholder="Select Roles"
                                                                                        name={`steps[${index}].roles`}
                                                                                        variant="filled"
                                                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                                                    />
                                                                                )}
                                                                                ListboxProps={{ sx: { fontSize: '13px' } }}
                                                                            />
                                                                            {touched?.steps?.[index]?.roles && errors?.steps?.[index]?.roles &&
                                                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.steps?.[index]?.roles}`}</FormHelperText>
                                                                            }
                                                                        </Grid2>

                                                                        {index > 0 && (
                                                                            <Grid2 xs={1}>
                                                                                <IconButton aria-label="delete" onClick={() => remove(index)}>
                                                                                    <DeleteIcon fontSize="inherit" color="error" />
                                                                                </IconButton>
                                                                            </Grid2>
                                                                        )}
                                                                    </Grid2>
                                                                </Box>
                                                            );
                                                        })}

                                                        <Button
                                                            onClick={() =>
                                                                push({ roles: [], stepName: '', tat: '', sequence: values?.steps?.length + 1 })
                                                            }
                                                            variant="outlined"
                                                            sx={{
                                                                color: `${newtheme?.customSettings?.themeColor}`,
                                                                border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                                                background: "none",
                                                                textTransform: "inherit",
                                                                padding: "6px 15px",
                                                                mt: 2,
                                                            }}
                                                        >
                                                            Next Step
                                                        </Button>
                                                    </>
                                                )}
                                            </FieldArray>
                                        </Grid2>
                                        {/* <Grid2 size={12}>
                                            <FieldArray name="roles">
                                                {({ push, remove }) => (
                                                    <>
                                                        {values?.roles?.map((role, index) => {
                                                            const selectedRoleIds = values?.roles
                                                                ?.map((r, i) => i !== index && r?.roleId)
                                                                .filter(Boolean);

                                                            const availableOptions = rolesData?.data?.data?.filter(
                                                                (option) => !selectedRoleIds.includes(option?.id)
                                                            ) || [];

                                                            return (
                                                                <Box key={index} sx={{ mb: 2 }}>
                                                                    <Grid2 container spacing={1}>
                                                                        <Grid2 size={index > 0 ? 11 : 12}>
                                                                            <Autocomplete
                                                                                options={availableOptions}
                                                                                getOptionLabel={(option) => option?.displayName || ''}
                                                                                value={
                                                                                    rolesData?.data?.data?.find(
                                                                                        (option) => option?.id === values?.roles[index]?.roleId
                                                                                    ) || null
                                                                                }
                                                                                onChange={(_, newValue) =>
                                                                                    setFieldValue(`roles[${index}].roleId`, newValue?.id || '')
                                                                                }
                                                                                onBlur={() =>
                                                                                    setTouched({
                                                                                        ...touched,
                                                                                        roles: {
                                                                                            ...touched.roles,
                                                                                            [index]: { roleId: true },
                                                                                        },
                                                                                    })
                                                                                }
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        label={`Step ${index + 1}`}
                                                                                        placeholder="Select Role"
                                                                                        name={`roles[${index}].roleId`}
                                                                                        variant="filled"
                                                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                                                    />
                                                                                )}
                                                                                ListboxProps={{
                                                                                    sx: { fontSize: '13px' },
                                                                                }}
                                                                            />

                                                                            {touched?.roles?.[index]?.roleId && errors?.roles?.[index]?.roleId && (
                                                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>
                                                                                    {errors?.roles?.[index]?.roleId}
                                                                                </FormHelperText>
                                                                            )}
                                                                        </Grid2>

                                                                        {index > 0 && (
                                                                            <Grid2 size={1}>
                                                                                <IconButton aria-label="delete" onClick={() => remove(index)}>
                                                                                    <DeleteIcon fontSize="inherit" color="error" variant="contained" />
                                                                                </IconButton>
                                                                                
                                                                            </Grid2>
                                                                        )}

                                                                    </Grid2>
                                                                </Box>
                                                            );
                                                        })}
                                                        <Button
                                                            onClick={() => push({ roleId: '', sequence: values?.roles?.length + 1 })}
                                                            variant="outlined"
                                                            sx={{
                                                                color: `${newtheme?.customSettings?.themeColor}`,
                                                                border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                                                background: "none",
                                                                textTransform: "inherit",
                                                                padding: "6px 15px",
                                                                marginTop: "12px !important",
                                                            }}
                                                        >
                                                            Next Step
                                                        </Button>
                                                    </>
                                                )}
                                            </FieldArray>

                                        </Grid2> */}
                                        <Grid2 size={12}>
                                            <Button
                                                type='submit'
                                                loading={addWorkflowRes?.isLoading}
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                                                    color: '#FFF', padding: '7px 20px',
                                                    fontWeight: '500', textTransform: 'none',
                                                    fontSize: '16px', float: 'right'
                                                }}>
                                                Save
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}